import { useState, useEffect } from "react";
import { Heading, Box, Text, Center, Tooltip, Flex, useColorMode, 
  useColorModeValue,
  theme,
} from "@chakra-ui/react";
// import {
//   FlexibleWidthXYPlot,
//   VerticalBarSeries,
//   LineSeries,
//   Crosshair,
//   XAxis,
// } from "react-vis";
import moment from "moment";
import PuffLoader from "react-spinners/PuffLoader";
import { QuestionIcon } from "@chakra-ui/icons";
import numbro from "numbro";
import { ComposedChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from 'recharts';

export function TweetAnalysis({
  stats = [],
  isLoading = false,
  previousDayStat = undefined,
  dateSeries = [],
}) {
  const [index, setIndex] = useState(null);
  const [hoveredPoint, setHoveredPoint] = useState<any>();
  const [data, setData] = useState<any>([]);
  const [crosshairValues, setCrosshairValues] = useState([]);
  const { colorMode } = useColorMode();
  
  const [distribution, setDistribution] = useState<any>([]);
  const [metricDistribution, setMetricDistribution] = useState<any>([]);


  let gap = 10;

  const distributionTweets = function (tweets, key="emoji", conf={} as any) {

    tweets = tweets.filter(t => !!t[key]);

    let likePoderation = conf.likePoderation ?? false;

    if (likePoderation) {
        var totalLikes = tweets.reduce((acc, curr) => acc + curr.favorite_count, 0);
        // console.log("totalLikes: " + totalLikes);
    }

    let allEmojis = Object.keys(tweets[0][key]);

    let emotions = {};
    allEmojis.forEach(e => {
        emotions[e] = 0;
    });

    // sum all emojis
    tweets.forEach(tweet => {
        allEmojis.forEach(e => {
            if (likePoderation) 
                emotions[e] += tweet[key][e] * tweet.favorite_count;
            else 
                emotions[e] += tweet[key][e];
        });
    })

    // average
    allEmojis.forEach(e => {
        if (likePoderation) 
            emotions[e] = emotions[e] / totalLikes;
        else 
            emotions[e] = emotions[e] / tweets?.length;
    });

    // convert in array for sorting
    let arrayEmotions = [] as any;
    for (let e in emotions) {
        arrayEmotions.push({emoji: e, value: emotions[e]});
    }
    // console.log(arrayEmotions);
    arrayEmotions = arrayEmotions.sort((a, b) => b.value - a.value);
    arrayEmotions = arrayEmotions.slice(0, 10);

    return arrayEmotions;
  }

  useEffect(() => {
    if (stats && stats?.length > 0) {
      
      let newDis = distributionTweets(stats, "emoji");
      newDis = newDis.map(t => {return {x: t.emoji, y: t.value}});

      let newDisMetric = distributionTweets(stats, "emoji", {likePoderation: true});
      // newDisMetric = newDisMetric.map(t => {return {x: t.emoji, yMetric: t.value}});
      newDis = newDis.map((t, i) => {return {...t, yMetric: newDisMetric[i].value}});

      setDistribution(newDis);
    } else {
      setDistribution([]);
    }
  }, [stats]);

  let newArr: any = data.slice().reverse();


  // @ts-ignore
  const hoveredData = data[index];

  return (
    <Box>
      <Flex alignItems="center">
        <Heading fontSize="xl">Emotion Analysis</Heading>
        <Tooltip
          hasArrow
          label={
            <>
              <Text>
                Your daily followers change is represented by bars and total
                followers in red.
              </Text>
              <br />
              <Text>
                Note: Analytics kicks off only after you activate it so there
                are chances you might see some blank spaces in charts because we
                won't have earlier data.
              </Text>
            </>
          }
        >
          <QuestionIcon color="gray.400" mt={1} ml={2} />
        </Tooltip>
      </Flex>
      {!isLoading && stats?.length <= 0 && (
        <Text p="8" textAlign="center">
          No chart data found. Please try a different timeframe
        </Text>
      )}
      {isLoading && (
        <Center pt={10}>
          <PuffLoader
            color={"hsl(203, 100%, 36%)"}
            loading={isLoading}
            css="display: block; margin: 0 auto; border-color: red;"
            size={50}
          />
        </Center>
      )}
      {!isLoading && (
        <Box position="relative" h="300px" maxW="100%" ml={{base: "0", md: "4"}} mt={{ base: "4", md: "8" }}>
            
            <ResponsiveContainer width="100%" height="100%">
              <ComposedChart
                // width={500}
                height={300}
                data={distribution}
              >
                <XAxis axisLine={true} tickLine={false} dataKey="x"/>
                {/* <XAxis  dataKey="x"/> */}
                <YAxis yAxisId="left" type="number" hide={true} />
                <Bar yAxisId="left" type="monotone" dataKey="y" fill={theme.colors.teal[600]} />
                <Bar yAxisId="left" type="monotone" dataKey="yMetric" fill={theme.colors.red[600]} />
                {/* <Legend verticalAlign="top" height={36}/> */}
                <RechartsTooltip content={({active, payload, label}) => {
                  // console.log(payload);
                  let distribValue: any = payload?.[0]?.value ?? 0;
                  let distribValueMetric: any = payload?.[1]?.value ?? 0;

                  return (
                    <Box
                      background={useColorModeValue("white", "gray.600")}
                      padding="4"
                      boxShadow="dark-lg"
                      color={useColorModeValue("black", "white")}
                      borderRadius="lg"
                      width="30"
                    >
                      <Text fontSize="sm"><b>{Math.round((distribValue)*100) + "%"}</b>{" of your tweets trigger the emotion " + payload?.[0]?.payload?.x + " but it represent "}<b>{Math.round((distribValueMetric)*100) + "%"}</b>{" of the likes"}</Text>
                      {/* <Text fontSize="11px">{"Tweets: " + Math.round((distribValue)*100) + "%"}</Text>
                      <Text fontSize="11px">{"Likes: " + Math.round((distribValueMetric)*100) + "%"}</Text> */}
                    </Box>
                  )
                }} />
              </ComposedChart>
            </ResponsiveContainer>

            {/* <FlexibleWidthXYPlot
              height={300}
              xType="ordinal"
              onMouseLeave={() => {
                setIndex(null);
                setCrosshairValues([]);
              }}
              onValueMouseOver={(value) => {
                setHoveredPoint(value);
              }}
              onValueMouseOut={() => setHoveredPoint(null)}
            >
              <VerticalBarSeries
                data={distribution}
                color="#15b7f7"
                colorType="literal"
              />
              <XAxis style={{text: {fontSize: "16px"}}} />
              <Crosshair values={crosshairValues}>
                <Box
                  background={useColorModeValue("white", "gray.600")}
                  padding="4"
                  boxShadow="dark-lg"
                  color={useColorModeValue("black", "white")}
                  borderRadius="xl"
                  textAlign="center"
                  width="28"
                >
                  <Text fontSize="11px">{hoveredPoint}</Text>
                </Box>
              </Crosshair>
            </FlexibleWidthXYPlot> */}
        </Box>
      )}
    </Box>
  );
}
